/**
 * Documentation-space writes the UI calls (card 4.3), each followed by the
 * scope reload the trees and the switcher read — one job at a time.
 */
import { createSpace, removeSpace, reorderSpaces, setNodeSpace, updateSpace } from './docSpacesStore';
import { addNewItemToActiveProject } from './projectItems';
import { getProjectScope, useProjectScopeStore } from './projectScopeStore';
import { refreshProjectScope } from './projectScopeLoader';
import { enqueueScopeJob } from './projectScopeJobs';
import { selectedSpaceOf, spacesOf, useDocSpaceSelection } from './docSpacesModel';

const reload = () => enqueueScopeJob(() => refreshProjectScope().catch(() => {}));
const warn = (err) => console.warn('[project-scope] documentation space write failed:', err);

/**
 * A new top-level page / folder made under a project joins it (decision 0.2)
 * and lands in the space the sidebar shows. Never throws.
 */
export async function addNewDocToActiveProject(nodeId, wireScope) {
  const added = await addNewItemToActiveProject(nodeId, wireScope);
  if (!added) return false;
  const { activeProject } = getProjectScope();
  const spaces = spacesOf(useProjectScopeStore.getState().known.docSpaces, activeProject.id);
  const spaceId = selectedSpaceOf(useDocSpaceSelection.getState().byProject, activeProject.id, spaces);
  if (!spaceId) return true;
  try {
    await setNodeSpace(activeProject, nodeId, spaceId);
    await reload();
  } catch (err) {
    warn(err);
  }
  return true;
}

export async function moveNodeToSpace(project, nodeId, spaceId) {
  await setNodeSpace(project, nodeId, spaceId);
  await reload();
}

export async function newSpace(project, fields, count) {
  const space = await createSpace(project, fields, count);
  await reload();
  useDocSpaceSelection.getState().select(project.id, space.id); // open the new space
  return space;
}

export async function editSpace(project, space, fields) {
  await updateSpace(project, space, fields);
  await reload();
}

export async function orderSpaces(project, spaces, ids) {
  await reorderSpaces(project, spaces, ids);
  await reload();
}

export async function deleteSpace(project, space, members) {
  await removeSpace(project, space, members);
  await reload();
}
